import { useState } from "react";
import "../../../styles/studio/folder/studioFolderListView.css";
import StudioFolderEntryRow from "./StudioFolderEntryRow.jsx";

/**
 * List view for folder entries with drag-and-drop reordering
 */
const StudioFolderListView = ({
  entries = [],
  setEntries,
  hoveredIndex,
  setHoveredIndex,
  currentFolderPath = [],
  globalLoading = false,
  isReorderMode = false,
  fetchData,
  setGlobalLoading,
  setError,
}) => {
  const [draggedIndex, setDraggedIndex] = useState(null);

  const handleDragStart = (e, index) => {
    if (!isReorderMode || globalLoading) return;
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e) => {
    if (!isReorderMode || globalLoading) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    if (!isReorderMode || globalLoading) return;
    if (draggedIndex === null || draggedIndex === dropIndex) return;

    const updated = [...entries];
    const [draggedItem] = updated.splice(draggedIndex, 1);

    const insertIndex = draggedIndex < dropIndex ? dropIndex - 1 : dropIndex;
    updated.splice(insertIndex, 0, draggedItem);

    setEntries(updated);
    setDraggedIndex(null);
  };

  const handleDragEnd = () => setDraggedIndex(null);

  return (
    <div className="studio-folder-list-view">
      {entries.map((entry, idx) => (
        <div
          key={entry.folderEntryId || entry.itemId}
          draggable={isReorderMode && !globalLoading}
          onDragStart={(e) => handleDragStart(e, idx)}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, idx)}
          onDragEnd={handleDragEnd}
        >
          <StudioFolderEntryRow
            entry={entry}
            index={idx}
            hovered={hoveredIndex === idx}
            onHover={() => setHoveredIndex(idx)}
            onLeave={() => setHoveredIndex(null)}
            currentFolderPath={currentFolderPath}
            globalLoading={globalLoading}
            fetchData={fetchData}
            setGlobalLoading={setGlobalLoading}
            setError={setError}
          />
        </div>
      ))}
    </div>
  );
};

export default StudioFolderListView;
